// eslint-disable-next-line arrow-body-style
const trimString = (value, trimFrom, trimTo) => {
  return value.slice(0, trimFrom) + value.slice(trimTo);
};

export default trimString;
